import { css } from 'linaria';

export const newKitchenGallerySectionTabs = css`
  && {
    margin-bottom: 32px;

    @media (--only-mobile) {
      margin-bottom: 24px;
    }
  }
`;

export const newKitchenGallerySectionMoreBtn = css`
  && {
    display: block;
    margin: 0 auto;

    @media (--only-mobile) {
      width: 100%;
      border-radius: var(--rounding-m);
    }
  }
`;
